import { render, staticRenderFns } from "./ContactPersonsList.vue?vue&type=template&id=7b79e6d6&scoped=true"
import script from "./ContactPersonsList.vue?vue&type=script&lang=js"
export * from "./ContactPersonsList.vue?vue&type=script&lang=js"
import style0 from "./ContactPersonsList.vue?vue&type=style&index=0&id=7b79e6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79e6d6",
  null
  
)

export default component.exports